
import { AssetPreviewUnavailableController } from './asset-preview-unavailable.controller'

function assetPreviewUnavailable () {
  return {
    restrict: 'E',
    scope: {
      asset: '<'
    },
    templateUrl: '/core/directives/asset-preview-unavailable/asset-preview-unavailable.html?$$REVISION$$',

    controller: AssetPreviewUnavailableController
  }
}
export { assetPreviewUnavailable }
